import React from 'react'

const domains = [
  {
    title: 'Quantitative Finance',
    text: 'Systematic research into price behavior, market structure, and statistical inefficiencies.'
  },
  {
    title: 'Machine Learning',
    text: 'Predictive modeling and feature engineering applied to financial time series.'
  },
  {
    title: 'Market Microstructure',
    text: 'Execution modeling and order flow analysis across fragmented markets.'
  },
  {
    title: 'Statistical Modeling',
    text: 'Probabilistic modeling and validation frameworks for financial systems.'
  },
  {
    title: 'Distributed Systems',
    text: 'High-throughput research infrastructure and scalable data pipelines.'
  },
  {
    title: 'Execution Optimization',
    text: 'Algorithmic execution strategies designed to minimize slippage and market impact.'
  },
]

const ResearchDomains = () => {
  return (
    <div id='research-domains' className='py-28 lg:py-32 xl:py-36 px-5 md:px-16 lg:px-20 flex flex-col justify-center items-center bg-white'>
      <div className='w-full max-w-screen-min-screen'>
        <h1 className='text-primary-dark metro-semi uppercase mb-5'>/ Research Areas</h1>
        <h1 className='text-secondary section-headline domin mb-10 lg:mb-12'>Core research domains spanning quantitative finance, machine learning, and execution infrastructure.</h1>
        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6'>
          {domains.map((domain, index) => (
            <div key={domain.title} className='bg-[#f1f1f1] p-6 border-l-2 border-[#26bfb5]'>
              <h2 className='text-secondary metro-semi text-[23px] mb-2'>{index + 1}. {domain.title}</h2>
              <p className='text-secondary-light metro text-[17px]'>{domain.text}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default ResearchDomains
